import { createSelector } from '@reduxjs/toolkit';
export var selectAuth = function (state) { return state.auth; };
export var selectView = function (state) { return state.view; };
export var selectHand = function (state) { return state.hand; };
export var selectUpload = function (state) { return state.upld; };
export var selectLibraries = function (state) { return state.libs; };
export var selectProrate = function (state) { return state.prrt; };
export var selectLibs = function (state) { return state.libs.librariesResponse; };
export var selectLicenses = function (state) { return state.lcns; };
export var selectKeys = function (state) { return state.keys; };
export var selectPrfn = function (state) { return state.prfn; };
export var selectPreferences = function (state) { return state.preferences; };
export var selectInit = function (state) { return state.init; };
export var selectAliases = function (state) { return state.aliases; };
export var selectTrainer = function (state) { return state.trainer; };
export var selectTrainerSettings = function (state) { return state.trainerSettings; };
export var selectTrainerActionHistory = function (state) { return state.trainerActionsHistory; };
export var selectTrainerSession = function (state) { return state.trainerSession; };
export var selectReports = function (state) { return state.reports; };
export var selectDashboard = function (state) { return state.userDashboard; };
export var selectHands = function (state) { return state.handsSlice; };
export var selectThreshold = function (state) { return state.preferences.dataNew.common.matrix.threshold; };
export var selectTooltipControl = function (state) { return state.preferences.dataNew.common.viewer; };
export var selectMatrixPreferences = function (state) { return state.preferences.dataNew.common.matrix; };
export var selectCommonPreferences = function (state) { return state.preferences.dataNew.common; };
export var selectDataNew = function (state) { return state.preferences.dataNew; };
// Reports
export var selectReportFlop = function (state) { return state.reports.flopAgg; };
export var selectReportRunout = function (state) { return state.reports.runoutsAgg; };
export var selectReportPosition = function (state) { return state.reports.positionReport; };
export var selectReportRake = function (state) { return state.reports.rakeReport; };
export var selectReportOpenRaise = function (state) { return state.reports.openRaiseReport; };
export var selectReportMultiStack = function (state) { return state.reports.multiStackReport; };
export var selectCurrentMultiReport = function (state) { return state.reports.currentMultiReport; };
export var multiStackSelector = createSelector([
    selectView,
    selectThreshold,
    selectReportMultiStack,
    selectReportPosition,
    selectReportRake,
    selectReportOpenRaise,
    selectCurrentMultiReport,
], function (_a, threshold, _b, _c, _d, _e, currentMultiReport) {
    var cacheAllStacks = _a.cacheAllStacks, strategyFilters = _a.strategyFilters, onePlayerOpacityFilters = _a.onePlayerOpacityFilters, isMoveOpacityFiltersMode = _a.isMoveOpacityFiltersMode, selected_hands_strategy = _a.selected_hands_strategy, moveModeStrategy = _a.moveModeStrategy, multiStackData = _a.multiStackData, currentQuery = _a.currentQuery, activeQuery = _a.activeQuery, spotId = _a.spotId, activeCardTraceIndex = _a.activeCardTraceIndex, trace = _a.trace, isRequestMultiStack = _a.isRequestMultiStack, multiStacks = _a.multiStacks, availableStacks = _a.availableStacks, isStackSelected = _a.isStackSelected, viewer_request_query = _a.viewer_request_query;
    var multiStackViewMode = _b.multiStackViewMode, currentMatrixStack = _b.currentMatrixStack;
    var currentPosition = _c.currentPosition, isReportNotAvailable = _c.positionData.isReportNotAvailable;
    var currentRake = _d.currentRake;
    var currentOpenRaise = _e.currentOpenRaise;
    return ({
        cacheAllStacks: cacheAllStacks,
        strategyFilters: strategyFilters,
        onePlayerOpacityFilters: onePlayerOpacityFilters,
        isMoveOpacityFiltersMode: isMoveOpacityFiltersMode,
        selected_hands_strategy: selected_hands_strategy,
        moveModeStrategy: moveModeStrategy,
        multiStackData: multiStackData,
        currentQuery: currentQuery,
        activeQuery: activeQuery,
        spotId: spotId,
        activeCardTraceIndex: activeCardTraceIndex,
        trace: trace,
        isRequestMultiStack: isRequestMultiStack,
        threshold: threshold,
        multiStackViewMode: multiStackViewMode,
        currentMatrixStack: currentMatrixStack,
        multiStacks: multiStacks,
        availableStacks: availableStacks,
        currentPosition: currentPosition,
        isReportNotAvailable: isReportNotAvailable,
        isStackSelected: isStackSelected,
        viewer_request_query: viewer_request_query,
        currentRake: currentRake,
        currentOpenRaise: currentOpenRaise,
        currentMultiReport: currentMultiReport,
    });
});
